import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../components/ui/Dialog';
import Button from '../components/ui/Button';

export function useConfirm() {
  const { t } = useTranslation('common');
  const [pending, setPending] = useState<{
    message: string;
    resolve: (value: boolean) => void;
  } | null>(null);

  const confirm = (message: string): Promise<boolean> =>
    new Promise(resolve => setPending({ message, resolve }));

  const handleConfirm = () => { pending?.resolve(true); setPending(null); };
  const handleCancel  = () => { pending?.resolve(false); setPending(null); };

  const ConfirmDialog = (
    <Dialog open={pending !== null} title={t('confirm')} onClose={handleCancel}>
      <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">{pending?.message}</p>
      <div className="flex justify-end gap-2">
        <Button variant="secondary" size="sm" onClick={handleCancel}>{t('cancel')}</Button>
        <Button variant="primary" size="sm" onClick={handleConfirm}>{t('confirm')}</Button>
      </div>
    </Dialog>
  );

  return { confirm, ConfirmDialog };
}
